import {
  getStateDirectoryUrl,
  getCityDirectoryUrl,
  getCategoryPath,
} from '../../../../../../core/util/seo';
import { BASE_URL } from '../../../../../../config';
import { sentenceCase } from '../../../../../../core/util/string';
import {
  formatLocationCategory,
  isTraditionalLocation,
  getLocationSpecialtyValue,
} from '../../../../../../core/util/location';
import {
  getProviderTypeSlug,
  getProviderTypeCrumbName,
} from '../../../../../Home/Tiles/ProviderTypes';

export const getCDPCrumbs = location => {
  const { city, state } = location;
  const category = formatLocationCategory(location);
  const specialtyValue = getLocationSpecialtyValue(location);
  const specialtyCrumbName = getProviderTypeCrumbName(specialtyValue);
  const specialtySlug = getProviderTypeSlug(specialtyValue);

  const categoryPathName = isTraditionalLocation(location) ? specialtyCrumbName : category;
  const categoryPathUrl = getCategoryPath(category);

  const statePathName = state.toUpperCase();
  const stateUrl = getStateDirectoryUrl(state);

  const cityPathName = sentenceCase(city);
  const cityPathUrl = getCityDirectoryUrl(state, city, specialtySlug);

  return [
    { name: 'Solv', href: BASE_URL },
    {
      name: categoryPathName,
      href: isTraditionalLocation(location) ? null : `${BASE_URL}${categoryPathUrl}`,
    },
    {
      name: statePathName,
      href: isTraditionalLocation(location) ? null : `${BASE_URL}${stateUrl}`,
    },
    {
      name: cityPathName,
      href: `${BASE_URL}${cityPathUrl}`,
    },
  ];
};
